import type { AppEnvType } from '../app-env';

export interface IRevenueCatVars {
  iosApiKey: string;
  androidApiKey: string;
  entitlementId: string;
}

export const revenueCatVars: Record<AppEnvType, IRevenueCatVars> = {
  local: {
    iosApiKey: 'appl_OChwsePKpGPdrkeuhSCrriTIfsv',
    androidApiKey: 'goog_spwNekwMrWnEAMuFcGoeIwZjXkk',
    entitlementId: 'Cool Mate Pro',
  },
  dev: {
    iosApiKey: 'appl_OChwsePKpGPdrkeuhSCrriTIfsv',
    androidApiKey: 'goog_spwNekwMrWnEAMuFcGoeIwZjXkk',
    entitlementId: 'Cool Mate Pro',
  },
  stg: {
    iosApiKey: 'appl_OChwsePKpGPdrkeuhSCrriTIfsv',
    androidApiKey: 'goog_spwNekwMrWnEAMuFcGoeIwZjXkk',
    entitlementId: 'Cool Mate Pro',
  },
  prod: {
    iosApiKey: 'appl_OChwsePKpGPdrkeuhSCrriTIfsv',
    androidApiKey: 'goog_spwNekwMrWnEAMuFcGoeIwZjXkk',
    entitlementId: 'Cool Mate Pro',
  },
};
